var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "container-fluid" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "row p-2" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.createDbs.apply(null, arguments)
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-store" }), _vm._v("Create Dbs")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-info",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.createAppActivity.apply(null, arguments)
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-plus" }), _vm._v("Create Issue")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-danger",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.createDuties.apply(null, arguments)
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-plus" }), _vm._v("Create duties")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-info",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.CreateAppQrActivity.apply(null, arguments)
                  }
                }
              },
              [
                _c("i", { staticClass: "fas fa-plus" }),
                _vm._v("Create qr cell issue")
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row p-2" }, [
          _c("div", { staticClass: "col-md-2" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-info",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.GetClaimList.apply(null, arguments)
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-list" }), _vm._v("List claims")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-info",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.GetUserList.apply(null, arguments)
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-list" }), _vm._v("List users")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-info",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.GetAccountList.apply(null, arguments)
                  }
                }
              },
              [
                _c("i", { staticClass: "fas fa-list" }),
                _vm._v("List accountnode")
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-info",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.GetAccountListCsv.apply(null, arguments)
                  }
                }
              },
              [
                _c("i", { staticClass: "fas fa-file-download" }),
                _vm._v("List accountnode csv")
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchStr,
                  expression: "searchStr"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.searchStr },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.searchStr = $event.target.value
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row p-2" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("form", { attrs: { enctype: "multipart/form-data" } }, [
              _c(
                "label",
                {
                  staticClass:
                    "btn btn-default btn-outline-secondary btn-file mb-1 w-100"
                },
                [
                  _c("input", {
                    ref: "fileUploadField",
                    staticStyle: { display: "none" },
                    attrs: { name: "upload", type: "file", size: "60" },
                    on: {
                      change: function($event) {
                        return _vm.onFilePicked()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa fa-paperclip" }),
                  _vm._v(" " + _vm._s(_vm.$t("btnAttachment")) + "\n          ")
                ]
              ),
              _vm._v(" "),
              _c("hr")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("UploadForm")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "jumbotron" }, [
          _c("h1", [_vm._v("ADMIN Info")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "jumbotron" }, [
        _c("h2", [_vm._v("Jobs upload")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }